import React from 'react';
// import '../../../styles/SourceDestination.css'; 
import LocationOnIcon from '@mui/icons-material/LocationOn';
import { } from "../../../"

interface SourceDestinationProps {
    source: string;
    destination: string
}

const SourceDestination: React.FC<SourceDestinationProps> = ({ source, destination }) => {


    return (
        <div>
            {source && (
                <div className="d-flex align-items-start mb-2">
                    <div className="me-2 mt-1">
                        <LocationOnIcon style={{ color: 'green' }} />
                    </div>
                    <div>
                        <p className="mb-1 fs-6 text-start pt-1">{source}</p>
                    </div>
                </div>
            )}

            {destination && (
                <div className="d-flex align-items-start mb-2">
                    <div className="me-2 mt-1">
                        <LocationOnIcon style={{ color: 'red' }} />
                    </div>
                    <div>
                        <p className="mb-1 fs-6 text-start pt-1">{destination}</p>
                    </div>
                </div>
            )}
        </div>

    );
};

export default SourceDestination;
